import React, {useCallback} from 'react';

import {IconButton, Table, Text, TrashBinIcon} from '@phonectas/unifon-ui-kit';

interface EmailNotificationTableRowProps {
    index: number;
    item: string;
    onDelete?: (index: number) => void;
}

const EmailNotificationTableRow: React.FC<EmailNotificationTableRowProps> = ({
	index,
	item,
	onDelete,
}) => {
	const handleDelete = useCallback(() => {
		if (onDelete) {
			onDelete(index);
		}
	}, [onDelete, index]);

	return (
		<Table.Row
			index={index}
			key={index}
		>
			<Table.Cell>{item}</Table.Cell>
			<Table.Cell>
				<Text>
					<IconButton
						disabled={!onDelete}
						color="error"
						onClick={handleDelete}
					>
						<TrashBinIcon />
					</IconButton>
				</Text>
			</Table.Cell>
		</Table.Row>
	);
}

export default EmailNotificationTableRow;
